package support

val deployment = Deployment(
    applicationKey = "D917AF5A-13B8-49E3-9A1B-DBE9112C9286",
    applicationSecret = "55D140E9-C411-4195-BC4B-A989E073CD0C",
    redirect = "",
    isSandbox = true,
    version = "1.0.4-SNAPSHOT",
    build = 9,
)